<template>
  <PatternModalWindow
    id="spb-pay"
    :titleWindow="titleWindow"
    @closeModal="closeModal()"
  >
    <div class="spb-pay_main"
         id="spb-pay_main"
    >
      <div class="block block__theme_content block__type_info">
        <div class="block block__image">
          <div class="svg"
               v-html="mobileImage"
          ></div>
        </div>

        <div class="block block__content">
           <span class="text">
            Через мобильное приложение банка
            отсканируйте QR-код и оплатите занятия
          </span>
        </div>
      </div>

      <div class="block block__theme_content block__type_qr qr">
        <div class="qr_image">
          <transition name="fadeFast" mode="out-in">
            <div class="qr_svg svg"
                 key="spb-image"
                 v-if="qrImage"
                 v-html="qrImage"
            ></div>

            <div class="spinner"
                 key="spb-loader"
                 v-else
            ></div>
          </transition>
        </div>
      </div>

      <div class="block block__management">
        <div class="block_help">
          <span class="text text__theme_help"
                @click="showHelpModal = true"
          >Не получается оплатить</span>

          <transition name="fade">
            <div class="modal_help"
                 v-if="showHelpModal"
            >
              QR-код может не читаться, если приложение вашего банка не поддерживает Систему быстрых платежей (СБП). Оплатите другим способом.
            </div>
          </transition>
        </div>

        <div class="button button__theme_default"
             @click="downloadSVG()"
        >
          Скачать QR код
        </div>
      </div>

      <div class="block block__management"
           v-if="isTester"
      >
        <div class="button button__theme_default button__theme_center"
             @click="testPay()"
        >
          Тестовая оплата
        </div>
      </div>
    </div>
  </PatternModalWindow>
</template>

<script>
import { saveAs } from 'file-saver';
import PatternModalWindow from "./PatternModalWindow";
import {qrImages} from '../../../svgStoreFiles';
import {checkClickOutside} from "@/helpers/events/clickOutside";
import {send} from "../../fetchData";
import {emitter} from "../../databus";

export default {
  name: "PaySPB",
  props: {
    titleWindow: { // наименование модального окна
      type: String,
      default: () => {
        return ''
      }
    },

    qrImage: { // изображение qr кода
      type: String,
      default: () => {
        return ''
      }
    },

    idOrder: { // id заказа - используется для тестирования
      type: [Number, String],
      default: () => {
        return undefined
      }
    },
  },

  data() {
    return {
      enableCloseModal: false, // разрешить закрыть модальное окно?
      mobileImage: qrImages.mobile,
      showHelpModal: false, // отобразить окно с помощью
      isTester: false, // пользователь является тестировщиком?
      textModalWaitingQuery: 'Генерация QR кода', // текст для блока загрузки
    }
  },

  created() {
    setTimeout(() => {
      this.enableCloseModal = true;
      document.getElementById('spb-pay_main').addEventListener('click', this.checkClickOutsideHelpBlock)
    }, 500);

    this.isTester = this.$store.state.auth.other.is_tester;
  },

  mounted() {

  },

  beforeUnmount() {
    document.getElementById('spb-pay_main').removeEventListener('click', this.checkClickOutsideHelpBlock)
  },

  methods: {
    // закрыть модальное окно
    closeModal() {
      if (this.enableCloseModal) this.$emit("closeModal");
    },

    // отслеживает клики вне блока помощи
    checkClickOutsideHelpBlock($event) {
      if (this.showHelpModal && checkClickOutside($event, 'DIV', 'block_help')) {
        this.showHelpModal = false;
      }
    },

    // скачать изображение
    downloadSVG() {
      saveAs(new Blob([this.qrImage], {type:"image/svg+xml"}), "qrCode.svg")
    },

    // тестовая оплата через СПБ
    testPay() {
      let data = {
        module: 'tinkoff_pay_demo_order_sbp',
        spb_order_id: this.idOrder,
      }

      send
        .post("payments_v2.php", data)
        .then((response) => {
          console.log('tinkoff_pay_demo_order_sbp');
          console.log(response);

          emitter.emit('TinkoffSBPPay', {
            idOrder: this.idOrder,
            idCourse: [this.$route.params.idCourse],
            status: !response.answer?.ErrorCode || (response.answer.ErrorCode == 0) ? 1 : 0, //  статус оплаты / 0 - ошибка / 1 - успех
          });
        })
        .catch((error) => {
          console.log("error", error)
          console.log(error.response)
        })
    },
  },

  computed: {},

  components: {
    PatternModalWindow,
  }
}
</script>

<style scoped lang="scss">
@import "../../../style/variables";

.spb-pay_main {
  display: flex;
  flex-direction: column;
  width: 540px;
}

.block__theme_content {
  background: $color_purple_bg_2;
  border-radius: 16px;
}

.svg {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.block__type_info {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  grid-gap: 24px;
  align-items: center;
  overflow: hidden;

  .block__content {
    padding: 28px 28px 28px 0;
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 21px;
  }

  .block__image {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    height: 100%;
  }
}

.block__type_qr {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  padding: 32px 0;

  .qr_image {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: white;
    padding: 33px;
    overflow: hidden;
    box-shadow: 0px 6px 8px -6px rgba(24, 39, 75, 0.12), 0px 8px 16px -6px rgba(24, 39, 75, 0.08);
    border-radius: 16px;
  }
}

.block_help {
  display: flex;
  flex-direction: row;
  position: relative;

  .modal_help {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 450px;
    background-color: white;
    padding: 14px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: 0px 6px 8px -6px rgba(24, 39, 75, 0.12), 0px 8px 16px -6px rgba(24, 39, 75, 0.08);
    border-radius: 8px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
  }
}

.block__management {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;

  .text__theme_help {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: $color_purple_3;
    transition: $transition_medium;
    cursor: pointer;

    &:hover {
      color: $color_purple_2;
      text-decoration: underline;
    }
  }

  .button__theme_default {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 0 32px;
    height: 52px;
    transition: $transition_medium;
    border-radius: 8px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: white;
    cursor: pointer;
    background-color: $color_purple_3;

    &:hover {
      background-color: $color_purple_2;
    }
  }

  .button__theme_center {
    margin: 0 auto;
  }
}

.spinner {
  height: 60px;
  width: 60px;
  border: 4px solid white;
  border-top-color: $color_purple_3;
  border-radius: 100%;
  animation: rotation 1.5s infinite linear 0.25s;
  opacity: 0;
}

@keyframes rotation {
  from {
    opacity: 1;
    transform: rotate(0deg);
  }
  to {
    opacity: 1;
    transform: rotate(359deg);
  }
}


@media all and (max-width: 1440px) {
  .spinner {
    height: 52px;
    width: 52px;
    border-width: 3px;
  }

  .spb-pay_main {
    width: 500px;
  }

  .block__theme_content {
    border-radius: 12px;
  }

  .block__type_info .block__content {
    padding: 22px 24px 22px 0;
    font-size: 16px;
    line-height: 20px;
  }

  .block__type_info {
    grid-gap: 20px;
  }

  .block__type_info .block__image .svg {
    height: 70px;
  }

  .block__type_qr {
    margin-top: 20px;
    padding: 24px 0;
  }

  .block__type_qr .qr_image {
    padding: 24px;
    border-radius: 12px;

    .svg {
      width: 220px;
      height: 220px;
    }
  }

  .block__management {
    margin-top: 20px;
  }

  .block__management .text__theme_help {
    font-size: 16px;
    line-height: 20px;
  }

  .block__management .button__theme_default {
    padding: 0 26px;
    height: 48px;
    font-size: 15px;
    line-height: 19px;
  }

  .block_help .modal_help {
    width: 410px;
    font-size: 15px;
    line-height: 140%;
  }
}

@media all and (max-width: 1280px) {
  .spinner {
    height: 48px;
    width: 48px;
  }
}

@media all and (max-width: 1160px) {
  .spinner {
    height: 52px;
    width: 52px;
    border-width: 3px;
  }

  .block__management {
    .text__theme_help {
      &:hover {
        color: $color_purple_3;
        text-decoration: none;
      }
    }

    .button__theme_default {
      &:hover {
        background-color: $color_purple_3;
      }
    }
  }
}

@media all and (max-width: 960px) {
  .spb-pay_main {
    width: calc(100vw - 60px - 28px - 28px);
  }
}

@media all and (max-width: 600px) {
  .spinner {
    height: 46px;
    width: 46px;
    border-width: 3px;
  }

  .spb-pay_main {
    width: auto;
  }

  .block__theme_content {
    border-radius: 10px;
  }

  .block__type_info {
    grid-gap: 18px;
  }

  .block__type_info .block__content {
    padding: 18px 20px 18px 0;
    font-size: 14px;
    line-height: 18px;
  }

  .block__type_info .block__image .svg {
    height: 74px;
    margin-left: -50px;
  }

  .block__type_qr {
    margin-top: 16px;
    padding: 20px 0;
  }

  .block__type_qr .qr_image {
    padding: 20px;
    border-radius: 10px;
  }

  .block__type_qr .qr_image .svg {
    width: 200px;
    height: 200px;
  }

  .block__management {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
  }

  .block_help {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .block__management .text__theme_help {
    font-size: 15px;
    line-height: 19px;
  }

  .block__management .button__theme_default {
    padding: 0 28px;
    height: 44px;
    font-size: 14px;
    line-height: 18px;
    margin-top: 10px;
  }

  .block_help .modal_help {
    width: calc(100vw - 28px - 30px);
    font-size: 14px;
    line-height: 18px;
  }
}
</style>